export default "__VITE_ASSET__DUC3aP0S__"